var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShieldActive = function SvgShieldActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Huge-icon/interface/outline/shield-check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5002 14.875L12.5451 16.5109C13.0327 16.9009 13.7408 16.838 14.1519 16.3682L17.5002 12.5416M6.27407 6.64211L12.1049 4.05065C13.3115 3.51437 14.6888 3.51437 15.8955 4.05065L21.7032 6.63184C23.4015 7.38665 24.5163 9.08311 24.3973 10.9378C23.9408 18.0519 21.9069 21.2679 16.4089 24.9989C14.958 25.9835 13.044 25.9811 11.5919 24.9981C6.1108 21.2873 4.00141 18.1161 3.58184 10.9129C3.47452 9.07034 4.58751 7.3917 6.27407 6.64211Z",
    stroke: "#3175F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShieldActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shield_active.b4591938.svg";
export { ForwardRef as ReactComponent };